/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_TitleInputs */

const en_admin_categories_title = /** @type {(inputs: Admin_Categories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const de_admin_categories_title = /** @type {(inputs: Admin_Categories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungen`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Admin_Categories_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_categories_title = /** @type {((inputs?: Admin_Categories_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_categories_title(inputs)
	return en_admin_categories_title(inputs)
});